import styled from 'styled-components';

export const StyledContainer = styled.div<{ isTextCenter?: boolean }>`
  text-align: ${({ isTextCenter }) => (isTextCenter ? 'center' : 'left')};
`;
